import { render } from "./UnsplashTag.vue?vue&type=template&id=2003c63e"
import script from "./UnsplashTag.vue?vue&type=script&lang=js"
export * from "./UnsplashTag.vue?vue&type=script&lang=js"

import "./UnsplashTag.vue?vue&type=style&index=0&id=2003c63e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__